import { createRpcClientV2 } from 'rpc-client-utils';
import httpClient from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
import { evaluateInAppRpc } from '../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService';
// errors thrown by hub-http add extra information to the error in hub-http#buildResponse
const isHubHttpError = error => Number.isInteger(error === null || error === void 0 ? void 0 : error.status);

// errors thrown by client-types operations add the original hub-http error to the `error.cause` in createHttpRpcClientV2
const isRpcError = error => !!error.cause && isHubHttpError(error.cause);
export const getSalesHubPurchaseMotionsForMerchCard = () => createRpcClientV2({
  hubHttpClient: httpClient
}).call(evaluateInAppRpc, {
  request: {
    locations: ['MERCH_CARD'],
    productApiNames: ['sales-hub-professional']
  }
}).catch(error => {
  if (!isRpcError(error) || error.cause.status !== 0) {
    Raven.captureException(error);
  }
  throw error;
});